import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { Form, Row } from "react-bootstrap";
import { useAuth } from "../../Context/AuthContext";
import Navbar from "../Navbar";
import Api from "../../Api/Api";
import { FaUser, FaEnvelope, FaLock } from "react-icons/fa";
import { toastError, toastSuccess } from "../../utilis/toast";
import axios from "axios";
import { API } from "../../API";
import { useAppContext } from "../../Context/AppContext";


const FormSignUp = () => {
  const { headerLogo } = useAppContext();

  const history = useHistory();
  const { signUp } = useAuth();

  const [data, setData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!data.firstName.trim()) newErrors.firstName = "First name is required.";
    if (!data.lastName.trim()) newErrors.lastName = "Last name is required.";
    if (!data.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email))
      newErrors.email = "Enter a valid email.";

    if (!data.password.trim()) newErrors.password = "Password is required.";
    else if (data.password.length < 8)
      newErrors.password = "Password must be at least 8 characters.";
    else if (!/(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]/.test(data.password))
      newErrors.password = "Password must include uppercase, lowercase, number, and special character.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formSubmitHandler = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setLoading(true);
      const response = await Api.SignUp(data);
      if (response?.status === "OK") {
        toastSuccess("Sign Up Successful");
        history.push("/login");
      }
      console.log(response);
    } catch (error) {
      toastError(error?.response?.data?.message || "Sign up failed. Please try again.");
      console.error("Sign up failed:", error);
    } finally {
      setLoading(false);
    }
  };




  return (
    <>
      <Navbar />
      <div className="form-signup-container">
        <div className="form-card">
          <div className="text-center mb-3">
            {
              headerLogo ? (
                <img src={headerLogo} alt="Logo" className="img-fluid" />
              ) : (
                <h1 className="text-primary fw-bold">SCOTT</h1>
              )}
          </div>
          <h3 className="text-center mb-4">Sign Up</h3>
          <Form onSubmit={formSubmitHandler}>
            <Row className="mb-3">
              <label htmlFor="firstName" className="form-label">
                First Name <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaUser />
                </span>
                <input
                  name="firstName"
                  type="text"
                  className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                  placeholder="First Name"
                  onChange={handleChange}
                />
                {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
              </div>
            </Row>

            <Row className="mb-3">
              <label htmlFor="lastName" className="form-label">
                Last Name <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaUser />
                </span>
                <input
                  name="lastName"
                  type="text"
                  className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                  placeholder="Last Name"
                  onChange={handleChange}
                />
                {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
              </div>
            </Row>

            <Row className="mb-3">
              <label htmlFor="email" className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaEnvelope />
                </span>
                <input
                  name="email"
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  placeholder="Email"
                  onChange={handleChange}
                />
                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
              </div>
            </Row>

            <Row className="mb-3">
              <label htmlFor="password" className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaLock />
                </span>
                <input
                  name="password"
                  type="password"
                  className={`form-control ${errors.password ? "is-invalid" : ""}`}
                  placeholder="Password"
                  onChange={handleChange}
                />
                {errors.password && <div className="invalid-feedback">{errors.password}</div>}
              </div>
            </Row>

            <Row className="text-center mb-3 p-2">
              <button
                className="btn btn-outline-primary w-100"
                type="submit"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Sign Up"}
              </button>
            </Row>
          </Form>
          <div className="text-center text-dark mt-3">
            Already have an account? <Link to="/login">Log in</Link>
          </div>
        </div>
      </div>
      <style jsx>{`
        .form-signup-container {
          margin-top: 80px; /* Adjust according to Navbar height */
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }
        .form-card {
          background: white;
          border-radius: 10px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          padding: 30px;
          width: 100%;
          max-width: 450px;
        }
      `}</style>
    </>
  );
};

export default FormSignUp;
